import {Modal, Button, Group} from '@mantine/core';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ModalFooter from 'ui-library/modals/ModalFooter';

export interface FlowchartRemoveNodeModalProps {
  nodeNames: Array<string>;
  onRequestRemove: () => void;
  onRequestClose: () => void;
  title: string;
  subtitle: React.ReactNode;
  opened?: boolean;
}

export default function FlowchartRemoveNodeModal(props: FlowchartRemoveNodeModalProps): JSX.Element {
  const {nodeNames, onRequestRemove, onRequestClose, title, subtitle, opened = true} = props;

  const isSingleNode = nodeNames.length === 1;

  const handleRemove = (): void => {
    onRequestRemove();
    onRequestClose();
  };

  const renderMessage = (): JSX.Element => {
    if (isSingleNode) {
      return <p className={css(styles.message)}>{subtitle}</p>;
    }

    return (
      <>
        <p className={css(styles.message)}>{subtitle}</p>
        <ul className={css(styles.list)}>
          {nodeNames.map((name, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      </>
    );
  };

  return (
    <Modal
      opened={opened}
      onClose={onRequestClose}
      title={title}
      size="md"
      closeButtonProps={{'aria-label': 'Close'}}
    >
      <div className={css(styles.content)}>{renderMessage()}</div>
      <ModalFooter>
        <Group position="right">
          <Button variant="tertiary" onClick={onRequestClose}>
            Cancel
          </Button>
          <Button type="submit" variant="warn" onClick={handleRemove} data-autofocus={true}>
            Remove
          </Button>
        </Group>
      </ModalFooter>
    </Modal>
  );
}

const styles = StyleSheet.create({
  content: {
    fontSize: '14px',
  },
  message: {
    margin: 0,
    lineHeight: '20px',
  },
  list: {
    margin: '8px 0 0 0',
    paddingLeft: '20px',
    lineHeight: '20px',
  },
});
